"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const LandingActions_1 = require("../landing/LandingActions");
const AuthenticationActions_1 = require("../authentication/AuthenticationActions");
const util_1 = require("util");
const react_bootstrap_1 = require("react-bootstrap");
const react_router_bootstrap_1 = require("react-router-bootstrap");
const LandingStore_1 = require("../landing/LandingStore");
const Video_1 = require("../landing/components/Video");
const Register_1 = require("../landing/components/Register");
const LoginDialog_1 = require("../landing/components/LoginDialog");
const SuccessPopup_1 = require("../landing/components/SuccessPopup");
const ForgotPassword_1 = require("../landing/components/ForgotPassword");
const ScrollToTop = require('react-scroll-up');
const { V_LOYAL_REACH } = require('../../../config');
function mapStateToProps(state) {
    return {
        landing: state.landingPage,
        authentication: state.authentication
    };
}
function mapDispatchToProps(dispatch) {
    return {
        openModal: (modal, src) => dispatch(LandingActions_1.openModal(modal, src)),
        logout: () => dispatch(AuthenticationActions_1.logoutUser())
    };
}
class LandingLayoutComponent extends React.Component {
    constructor(props) {
        super(props);
        this.openLogin = this.openLogin.bind(this);
        this.openRegister = this.openRegister.bind(this);
        this.openVideo = this.openVideo.bind(this);
    }
    openLogin() {
        this.props.openModal(LandingStore_1.LandingModal.Login);
    }
    openRegister() {
        this.props.openModal(LandingStore_1.LandingModal.Register);
    }
    openVideo() {
        this.props.openModal(LandingStore_1.LandingModal.Video);
    }
    getModalDialog(landing) {
        let modalDialog;
        switch (landing.modal) {
            case LandingStore_1.LandingModal.Login:
                modalDialog = React.createElement(LoginDialog_1.default, null);
                break;
            case LandingStore_1.LandingModal.Register:
                modalDialog = React.createElement(Register_1.default, null);
                break;
            case LandingStore_1.LandingModal.ForgotPassword:
                modalDialog = React.createElement(ForgotPassword_1.default, { openModal: this.props.openModal });
                break;
            case LandingStore_1.LandingModal.Video:
                modalDialog = React.createElement(Video_1.default, { src: landing.src, openModal: this.props.openModal });
                break;
            case LandingStore_1.LandingModal.SuccessPopup:
                modalDialog = React.createElement(SuccessPopup_1.default, { openModal: this.props.openModal });
                break;
            default:
                break;
        }
        return modalDialog;
    }
    getNavAuthentication(authentication) {
        let authNavItems = [];
        if (util_1.isNullOrUndefined(authentication.accessToken)) {
            authNavItems.push(React.createElement(react_router_bootstrap_1.LinkContainer, { key: "login-link", to: "/", "data-cy": "loginLink", id: "loginItem", onClick: () => {
                    this.props.openModal(LandingStore_1.LandingModal.Login);document.body.scrollTop = 0;
                } }, React.createElement(react_bootstrap_1.NavItem, { eventKey: 5 }, "Login")));
            authNavItems.push(React.createElement(react_router_bootstrap_1.LinkContainer, { key: "register-link", to: "/", "data-cy": "signUpLink", id: "registerItem", onClick: () => {
                    this.props.openModal(LandingStore_1.LandingModal.Register);document.body.scrollTop = 0;
                } }, React.createElement(react_bootstrap_1.NavItem, { eventKey: 6 }, "Register")));
        } else {
            authNavItems.push(React.createElement("li", { key: "dashboard-link" }, React.createElement("a", { href: `/${authentication.organization.routePrefix}/app` }, "Dashboard")));
            authNavItems.push(React.createElement(react_bootstrap_1.NavItem, { key: "logout-link", onClick: () => {
                    this.props.logout();
                } }, "Logout"));
        }
        return authNavItems;
    }
    render() {
        const { landing, authentication } = this.props;
        return React.createElement("div", null, React.createElement("link", { href: `/css/main.css?V_LOYAL_REACH=${V_LOYAL_REACH}`, rel: "stylesheet" }), React.createElement("link", { href: `/css/slide.css?V_LOYAL_REACH=${V_LOYAL_REACH}`, rel: "stylesheet" }), React.createElement("link", { href: "https://fonts.googleapis.com/css?family=Montserrat:100,200,400", rel: "stylesheet" }), this.getModalDialog(landing), React.createElement(react_bootstrap_1.Navbar, { fluid: true, collapseOnSelect: true }, React.createElement(react_bootstrap_1.Navbar.Header, null, React.createElement(react_bootstrap_1.Navbar.Brand, null, React.createElement("a", { className: "logo_web pull-left", href: "/" }, React.createElement(react_bootstrap_1.Image, { src: '../img/logo_2.png', responsive: true }))), React.createElement(react_bootstrap_1.Navbar.Toggle, null)), React.createElement(react_bootstrap_1.Navbar.Collapse, null, React.createElement("ul", { className: "nav navbar-nav navbar-right" }, React.createElement(react_router_bootstrap_1.IndexLinkContainer, { to: "/", id: "homeItem" }, React.createElement(react_bootstrap_1.NavItem, { eventKey: 1 }, "Home")), React.createElement(react_router_bootstrap_1.LinkContainer, { to: "/service", id: "serviceItem" }, React.createElement(react_bootstrap_1.NavItem, { eventKey: 2 }, "How it Works")), React.createElement(react_router_bootstrap_1.LinkContainer, { to: "/about", id: "aboutItem" }, React.createElement(react_bootstrap_1.NavItem, { eventKey: 3 }, "Why Us")), React.createElement(react_router_bootstrap_1.LinkContainer, { to: "/#contact", id: "contactItem" }, React.createElement(react_bootstrap_1.NavItem, { eventKey: 4 }, "Contact")), this.getNavAuthentication(authentication)))), React.createElement(ScrollToTop, { showUnder: 350 }, React.createElement("p", { className: "pull-right backtotop" }, React.createElement("a", { href: "#top", className: "gototop" }, React.createElement("button", { type: "button", className: "btn btn-default btn-circle " }, React.createElement("i", { className: "fa fa-chevron-up" })), " "))), this.props.children);
    }
}
const LandingLayout = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LandingLayoutComponent);
exports.default = LandingLayout;


//////////////////
// WEBPACK FOOTER
// ./client/src/layout/LandingLayout.tsx
// module id = 786
// module chunks = 0 1